const sharedTokens = {
  teal: '#38e8ff',
  tealDeep: '#14a2ba',
  gold: '#f3bf4d',
  red: '#ff6b6b',
  green: '#20b26b'
} as const;

export const designModes = {
  light: {
    page: '#f5f5f7',
    pageSoft: '#e9edf2',
    surface: '#ffffff',
    surfaceRaised: '#fbfbfd',
    border: 'rgba(29,29,31,0.11)',
    borderStrong: 'rgba(20,162,186,0.28)',
    text: '#1d1d1f',
    textMuted: '#6e6e73',
    ...sharedTokens
  },
  dark: {
    page: '#070b12',
    pageSoft: '#0c1420',
    surface: '#101a27',
    surfaceRaised: '#142232',
    border: 'rgba(255,255,255,0.12)',
    borderStrong: 'rgba(56,232,255,0.42)',
    text: '#f7fbff',
    textMuted: '#9fb0c4',
    ...sharedTokens,
    green: '#67e8a5'
  }
} as const;

export type DesignMode = keyof typeof designModes;

export const getDesignTokens = (mode: DesignMode = 'light') => ({
  colors: designModes[mode],
  layout: {
    contentMax: 1320,
    readingMax: 760,
    toolMax: 1180
  },
  spacing: {
    pageX: { xs: 2, sm: 3, md: 5 },
    sectionY: { xs: 6, md: 9 },
    sectionHeaderToContent: { xs: 2.5, md: 3.5 },
    componentGap: { xs: 2, md: 2.5 },
    cardGap: { xs: 2, md: 3 },
    fieldGap: { xs: 1.5, md: 1.9 },
    inlineGap: 1.2
  },
  radius: {
    sm: 2,
    md: 3,
    lg: 3.5
  },
  shadow: {
    focus: '0 0 0 3px rgba(56,232,255,0.26)',
    raised:
      mode === 'light'
        ? '0 22px 60px rgba(0,0,0,0.08)'
        : '0 18px 48px rgba(0,0,0,0.32)'
  }
});

export const designTokens = {
  colors: {
    ...designModes.dark
  },
  layout: {
    contentMax: 1320,
    readingMax: 760,
    toolMax: 1180
  },
  spacing: {
    pageX: { xs: 2, sm: 3, md: 5 },
    sectionY: { xs: 6, md: 9 },
    sectionHeaderToContent: { xs: 2.5, md: 3.5 },
    componentGap: { xs: 2, md: 2.5 },
    cardGap: { xs: 2, md: 3 },
    fieldGap: { xs: 1.5, md: 1.9 },
    inlineGap: 1.2
  },
  radius: {
    sm: 2,
    md: 3,
    lg: 3.5
  },
  shadow: {
    focus: '0 0 0 3px rgba(56,232,255,0.26)',
    raised: '0 18px 48px rgba(0,0,0,0.32)'
  }
} as const;

export type DesignColor = keyof typeof designTokens.colors;
